export const NUMBERS_ONLY = /^\d+$/;
export const DECIMAL_2_PLACES = /^\d+\.\d{0,2}$/;
export const LETTERS_ONLY = /^[A-Z]$/;
export const CONTAINS_T = /[T]/;



// WEBPACK FOOTER //
// ./src/constants/regex.js